module.exports = __webpack_public_path__ + "media/images/site/serie-b-86124643198e4160170a0902370b008c.png";